import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Button,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Breadcrumbs,
  TextField,
  Alert,
  Grid,
  OutlinedInput,
  Checkbox,
  ListItemText
} from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useGet, usePut } from '../../API/request';
import { BallTriangle } from 'react-loader-spinner';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import '../../styles/Avatar/style.css';
import 'react-quill/dist/quill.snow.css';

const BannerEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const getU = useGet();
  const putU = usePut();

  const [isLoaded, setIsLoaded] = useState(true);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [nothingChanged, setNothingChanged] = useState(true);

  const [uploadedMobile, setUploadedMobile] = useState(
    '/static/images/defphoto.jpg'
  );
  const [uploadedMainImg, setUploadedMainImg] = useState(
    '/static/images/defphoto.jpg'
  );
  const [values, setValues] = useState({
    title: '',
    city_id: []
  });
  const [errors, setErrors] = useState({
    title: false,
    city_id: false,
    url: false
  });

  const [cities, setCities] = useState([]);
  const [choosenCities, setChoosenCities] = useState([]);
  const [selectCitys, setSelectCitys] = useState({});

  const [alert, setAlert] = useState({
    txt: '',
    type: 'error',
    number: 0
  });

  const loadData = () => {
    setIsLoaded(true);
    const selectList = [];
    getU(`city`)
      .then((resp) => {
        if (resp.status === 'success') {
          setCities(resp.data.city);

          resp.data.city.forEach((item) => {
            selectList.push({
              name: item.name,
              city_id: item.id,
              banner_id: Number(id),
              id: null,
              error: false,
              url: '',
              show: false
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        getU(`banners/${id}`)
          .then((resp) => {
            if (resp.status === 'success') {
              const data = {
                ...resp.data.banner
              };
              const mobile_img = resp.data.banner.mobile_img
                ? `${process.env.REACT_APP_API_URL}public/uploads/images/${resp.data.banner.mobile_img}`
                : '';

              const desktop_img = resp.data.banner.desktop_img
                ? `${process.env.REACT_APP_API_URL}public/uploads/images/${resp.data.banner.desktop_img}`
                : '';
              setValues({
                title: data.title,
                city_id: data.url.map((el) => el.city_id)
              });

              if (data.url.length > 0) {
                data.url.forEach((item) => {
                  const currentCity = selectList.find(
                    (city) => city.city_id === item.city_id
                  );

                  if (currentCity) {
                    currentCity.id = item.id;
                    currentCity.url = item.url;
                  }
                });
              }
              setSelectCitys(selectList);

              setUploadedMobile(mobile_img);
              setUploadedMainImg(desktop_img);
              setChoosenCities(
                selectList.map((el) => el.id && el.name && el.name).filter((item) => item)
              );
            }
          })
          .catch((e) => {
            showAlert(
              1,
              'error',
              'Произошла ошибка при загрузке сервиса, попробуйте перезайти'
            );
            console.log(e);
          })
          .finally(() => {
            setIsLoaded(false);
          });
      });
  }

  const handleChange = (event, name) => {
    setNothingChanged(false);
    setValues({
      ...values,
      [name]: event.target.value // Для остальных полей
    });
    setErrors({
      ...errors,
      [name]: false
    });
  };

  const handleChangeCity = (event) => {
    setNothingChanged(false);
    const value = event.target.value;
    setChoosenCities(value);
    setValues({
      ...values,
      city_id: value?.map((el) => cities?.find((elem) => elem.name === el)?.id)
    });
    setErrors({
      ...errors,
      city_id: false
    });
  };

  const avaUploaded = (event) => {
    setNothingChanged(false);
    setUploadedMobile(URL.createObjectURL(event.target.files[0]));
    setValues({
      ...values,
      mobile_img: event.target.files[0]
    });
  };

  const changeValuesLinks = (e, name) => {
    const value = e.target.value;

    setSelectCitys((prev) =>
      prev.map((item) =>
        item.name === name ? { ...item, url: value, error: false } : item
      )
    );
    setNothingChanged(false);
  };

  const mainImgUploaded = (event) => {
    setNothingChanged(false);
    setUploadedMainImg(URL.createObjectURL(event.target.files[0]));
    setValues({
      ...values,
      desktop_img: event.target.files[0]
    });
  };

  const showAlert = (number, type, text) => {
    setAlert({
      txt: text,
      type,
      number
    });

    setTimeout(() => {
      setAlert({
        txt: text,
        type,
        number: 0
      });

      setSubmitDisabled(false);
    }, 2500);
  };

  const validate = () => {
    let validComplete = true;
    let formErrors = { ...errors };

    if (values.title === '') {
      validComplete = false;
      formErrors.fio = false;
      showAlert(3, 'error', 'Имя услуги не должно быть пустым');
    }
    if (values.city_id.length === 0) {
      validComplete = false;
      formErrors.city_id = false;
      showAlert(
        3,
        'error',
        'Поле Массив связных городов не должно быть пустым'
      );
    }

    const urlRegex = /^(http|https)/;

    setSelectCitys((prev) =>
      prev.map((item) =>
        item.url === 0 || !urlRegex.test(item.url)
          ? { ...item, error: true }
          : item
      )
    );

    selectCitys.forEach((item) => {
      if (item.url.length === 0 && values.city_id.includes(item.city_id)) {
        validComplete = false;
        showAlert(3, 'error', 'Поле ссылка не должна быть пустым');
      } else if (item.url.length > 0 && !urlRegex.test(item.url)) {
        validComplete = false;
        showAlert(3, 'error', 'Введите корректную ссылку');
      }
    });

    setErrors(formErrors);
    return validComplete;
  };

  const submitMobileImg = async () => {
    if (nothingChanged) {
      showAlert(1, 'error', 'Нет изменений');
      return;
    }
    setSubmitDisabled(true);

    let data = new FormData();
    data.append('img', values.mobile_img);

    putU(`banners/mobile/${id}`, data)
      .then((resp) => {
        if (resp.status === 'success') {
          showAlert(1, 'success', 'Данные успешно обновленны');
        } else {
          showAlert(1, 'error', 'Ошибка');
        }
      })
      .catch((err) => {
        showAlert(1, 'error', 'Ошибка сервера');
      })
      .finally(() => {
        setSubmitDisabled(false);
      });
  };

  const submitDesktopImg = async () => {
    if (nothingChanged) {
      showAlert(2, 'error', 'Нет изменений');
      return;
    }
    setSubmitDisabled(true);

    let data = new FormData();
    data.append('img', values.desktop_img);

    putU(`banners/desktop/${id}`, data)
      .then((resp) => {
        if (resp.status === 'success') {
          showAlert(2, 'success', 'Данные успешно обновленны');
        } else {
          showAlert(2, 'error', 'Ошибка');
        }
      })
      .catch((err) => {
        showAlert(2, 'error', 'Ошибка сервера');
      })
      .finally(() => {
        setSubmitDisabled(false);
      });
  };

// console.log(selectCitys)

const getLinkStatus = (item) => {
  if (item.id && values.city_id.includes(item.city_id)) {
    return 'update'
  }
  if (!item.id && values.city_id.includes(item.city_id)) {
    return 'create'
  }
  if (item.id && !values.city_id.includes(item.city_id)) {
    return 'delete'
  }
}

  const submitEditLinks = () => {
    if (!id) return;
    const url = `banners/url/${id}`;

    const urls = selectCitys
      .map(
        (item) =>(
           {
            city_id: item.city_id,
            url: item.url,
            status: getLinkStatus(item),
          })
      )
      .filter((item) => item.status);

    const data = { urls };


    putU(url, data)
      .then((resp) => {
        if (resp.status === 'success') {
          loadData();
        } else {
          showAlert(3, 'error', 'Ошибка');
        }
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.message || 'Произошла ошибка';
        showAlert(3, 'error', errorMessage);
      });
  };

  const submitInfo = async () => {
    if (nothingChanged) {
      showAlert(3, 'error', 'Нет изменений');
      return;
    }

    const isValid = validate();

    if (!isValid) return;

    setSubmitDisabled(true);

    const data = {
      title: values.title,
      city_id: values.city_id
    };

    putU(`banners/data/${id}`, data)
      .then((resp) => {
        if (resp.status === 'success') {
          showAlert(3, 'success', 'Данные успешно обновленны');
          submitEditLinks();
        } else {
          showAlert(3, 'error', 'Ошибка');
        }
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.message || 'Произошла ошибка';
        showAlert(3, 'error', errorMessage);
      })
      .finally(() => {
        setSubmitDisabled(false);
      });
  };



  useEffect(() => {
  loadData();
  }, [id]);

  if (isLoaded) {
    return (
      <div className="loader">
        <BallTriangle
          height="100"
          width="100"
          color="grey"
          ariaLabel="loading"
        />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Редактирование баннера</title>
      </Helmet>
      <Box sx={{ pt: 2 }}>
        <Container maxWidth={false}>
          <Button startIcon={<ChevronLeft />} onClick={() => navigate(-1)}>
            Назад
          </Button>
          <Breadcrumbs aria-label="breadcrumb" style={{ fontSize: 14 }}>
            <Link underline="hover" color="inherit" to="/app/banners">
              Баннера
            </Link>
            <p>Редактирование баннера</p>
          </Breadcrumbs>
        </Container>
      </Box>

      {/*preview*/}
      <Box sx={{ backgroundColor: 'background.default', pt: 3 }}>
        <Container maxWidth={false}>
          <Box sx={{ mb: 1 }}>
            <Alert
              severity={alert.type}
              style={{ display: alert.number === 1 ? 'flex' : 'none' }}
            >
              {alert.txt}
            </Alert>
          </Box>
          <Box
            sx={{
              paddingBottom: 1
            }}
          >
            <form>
              <Card>
                <CardHeader title="Редактирование мобильного изображения" />
                <Divider />
                <CardContent sx={{ position: 'relative' }}>
                  <div className="itemWrapper">
                    <div className="container">
                      <input
                        accept="xlsx/*"
                        type="file"
                        style={{ display: 'none' }}
                        id={1}
                        onChange={(event) => avaUploaded(event, 1)}
                      />
                      <label htmlFor={1}>
                        <img
                          src={uploadedMobile || '/static/images/defphoto.jpg'}
                          className="itemImg"
                        />
                        <div className="middle" />
                      </label>
                    </div>
                    <div className="help-text">
                      Доступны следующие расширения: .png .jpg .svg .bmp .tga
                      .webp
                    </div>
                  </div>
                </CardContent>
                <Divider />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={submitMobileImg}
                    disabled={submitDisabled}
                  >
                    Сохранить
                  </Button>
                </Box>
              </Card>
            </form>
          </Box>
        </Container>
      </Box>

      {/*desktop_img*/}
      <Box sx={{ backgroundColor: 'background.default', pt: 3 }}>
        <Container maxWidth={false}>
          <Box sx={{ mb: 1 }}>
            <Alert
              severity={alert.type}
              style={{ display: alert.number === 2 ? 'flex' : 'none' }}
            >
              {alert.txt}
            </Alert>
          </Box>
          <Box
            sx={{
              paddingBottom: 1
            }}
          >
            <form>
              <Card>
                <CardHeader title="Редактирование десктопного изображения" />
                <Divider />
                <CardContent sx={{ position: 'relative' }}>
                  <div className="itemWrapper">
                    <div className="container">
                      <input
                        accept="xlsx/*"
                        type="file"
                        style={{ display: 'none' }}
                        id={2}
                        onChange={(event) => mainImgUploaded(event, 1)}
                      />
                      <label htmlFor={2}>
                        <img
                          src={uploadedMainImg || '/static/images/defphoto.jpg'}
                          className="itemMainImg"
                        />
                        <div className="middle" />
                      </label>
                    </div>
                    <div className="help-text">
                      Доступны следующие расширения: .png .jpg .svg .bmp .tga
                      .webp
                    </div>
                  </div>
                </CardContent>
                <Divider />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={submitDesktopImg}
                    disabled={submitDisabled}
                  >
                    Сохранить
                  </Button>
                </Box>
              </Card>
            </form>
          </Box>
        </Container>
      </Box>

      {/*info*/}
      <Box sx={{ backgroundColor: 'background.default', pt: 3 }}>
        <Container maxWidth={false}>
          <Box
            sx={{
              paddingBottom: 1
            }}
          >
            <form>
              <Card>
                <CardHeader title="Редактирование услуги" />
                <Divider />
                <CardContent sx={{ position: 'relative' }}>
                  <TextField
                    fullWidth
                    label="Заголовок"
                    margin="normal"
                    name="title"
                    onChange={(event) => handleChange(event, 'title')}
                    type="text"
                    value={values.title || ''}
                    variant="outlined"
                    error={errors.title}
                  />
                  <FormControl fullWidth sx={{ mt: 2, mb: 1 }}>
                    <InputLabel id="Города">Города</InputLabel>
                    <Select
                      label="Города"
                      name="city_id"
                      multiple
                      value={choosenCities || ''}
                      onChange={handleChangeCity}
                      input={<OutlinedInput label="Города" />}
                      renderValue={(selected) => selected.join(', ')}
                    >
                      {cities?.map((city) => (
                        <MenuItem key={city.name} value={city.name}>
                          <Checkbox
                            checked={choosenCities?.indexOf(city.name) > -1}
                          />
                          <ListItemText primary={city.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {selectCitys.length > 0 &&
                    selectCitys.map((city) => {
                      return (
                        values.city_id.includes(city.city_id) && (
                          <TextField
                            key={city.name}
                            fullWidth
                            label={`Ссылка для ${city.name}`}
                            margin="normal"
                            name="url"
                            onChange={(event) =>
                              changeValuesLinks(event, city.name)
                            }
                            type="textarea"
                            multiline
                            value={city.url}
                            variant="outlined"
                            error={city.error}
                          />
                        )
                      );
                    })}

                  <Alert
                    severity={alert.type}
                    style={{ display: alert.number === 3 ? 'flex' : 'none' }}
                  >
                    {alert.txt}
                  </Alert>
                </CardContent>
                <Divider />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={submitInfo}
                    disabled={submitDisabled}
                  >
                    Сохранить
                  </Button>
                </Box>
              </Card>
            </form>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default BannerEdit;
